import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useFirebase } from '../../context/firebaseContext';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const RegisterMobile = () => {
    const { auth, db } = useFirebase();
    const navigate = useNavigate();
    const [userRegistration, setUserRegistration] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        username: '',
    });
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    useEffect(() => {
        const successMessageTimeout = setTimeout(() => {
            setSuccessMessage(null);
        }, 3000);

        return () => clearTimeout(successMessageTimeout);
    }, [successMessage]);

    const handleChange = (e) => {
        const { name, value } = e.currentTarget;
        setUserRegistration({
            ...userRegistration,
            [name]: value,
        });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        const { email, password, confirmPassword, username } = userRegistration;

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        try {
            setError(null);

            // Register the user using Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Write the username to Firestore
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, { username, email });

            setSuccessMessage('Registration successful! Redirecting to login...');
            setTimeout(() => navigate('/mobile/login'), 2000);
        } catch (error) {
            console.error('Registration error:', error.message);
            setError('Registration failed. Please try again.');
        }
    };

    return (
        <div className="mobile-login-container">
            <div className="mobile-login-card">
                <div className="mobile-login-header">
                    <h1 className="mobile-login-title">Create Account</h1>
                    <p className="mobile-login-subtitle">Join our community</p>
                </div>

            <form onSubmit={handleRegister} className="mobile-login-form">
                {/* Username Field */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Enter your username"
                            value={userRegistration.username}
                            onChange={handleChange}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '1rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faUser} style={{ fontSize: '16px' }} />
                        </span>
                    </div>
                </div>

                {/* Email Field */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type="email"
                            id="email"
                            name="email"
                            placeholder="Enter your email address"
                            value={userRegistration.email}
                            onChange={handleChange}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '1rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '16px' }} />
                        </span>
                    </div>
                </div>

                {/* Password Field */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            value={userRegistration.password}
                            onChange={handleChange}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '2.5rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faLock} style={{ fontSize: '16px' }} />
                        </span>
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                color: '#FFD700',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} style={{ fontSize: '16px' }} />
                        </button>
                    </div>
                </div>

                {/* Confirm Password Field */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type={showConfirmPassword ? 'text' : 'password'}
                            id="confirmPassword"
                            name="confirmPassword"
                            placeholder="Confirm your password"
                            value={userRegistration.confirmPassword}
                            onChange={handleChange}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '2.5rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faLock} style={{ fontSize: '16px' }} />
                        </span>
                        <button
                            type="button"
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                color: '#FFD700',
                                cursor: 'pointer',
                                zIndex: 2
                            }}
                        >
                            <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} style={{ fontSize: '16px' }} />
                        </button>
                    </div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="mobile-error-message" style={{
                        background: 'rgba(255, 0, 0, 0.1)',
                        border: '1px solid rgba(255, 0, 0, 0.3)',
                        color: '#ff6b6b',
                        borderRadius: '8px',
                        padding: '0.75rem',
                        marginBottom: '1rem',
                        fontSize: '0.875rem'
                    }}>
                        {error}
                    </div>
                )}

                {/* Success Message */}
                {successMessage && (
                    <div style={{
                        background: 'rgba(0, 255, 0, 0.1)',
                        border: '1px solid rgba(0, 255, 0, 0.3)',
                        color: '#4CAF50',
                        borderRadius: '8px',
                        padding: '0.75rem',
                        marginBottom: '1rem',
                        fontSize: '0.875rem'
                    }}>
                        {successMessage}
                    </div>
                )}

                {/* Submit Button */}
                <div className="mobile-form-group">
                    <div className="control">
                        <button
                            type="submit"
                            className="mobile-login-button"
                            style={{
                                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '0.75rem 1.5rem',
                                fontSize: '1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)',
                                color: 'var(--mobile-contrast)',
                                width: '100%',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(255, 215, 0, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(255, 215, 0, 0.3)';
                            }}
                        >
                            Create Account
                        </button>
                    </div>
                </div>

                {/* Links */}
                <div className="mobile-login-footer">
                    <p className="mobile-login-text" style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                        Already have an account?{' '}
                        <Link to="/mobile/login" style={{ color: '#FFA500', textDecoration: 'underline' }}>
                            Sign in here
                        </Link>
                    </p>
                </div>
            </form>
            </div>
        </div>
    );
};

export default RegisterMobile; 
